var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_79_24)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_79_24",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 31,
    height: 31
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 0.5H0.5V30.5H30.5V0.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_79_24)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8334 11.5C20.8334 12.9145 20.2715 14.271 19.2713 15.2712C18.2711 16.2714 16.9146 16.8333 15.5001 16.8333C14.0856 16.8333 12.729 16.2714 11.7288 15.2712C10.7287 14.271 10.1667 12.9145 10.1667 11.5C10.1667 10.0855 10.7287 8.72895 11.7288 7.72875C12.729 6.72856 14.0856 6.16666 15.5001 6.16666C16.9146 6.16666 18.2711 6.72856 19.2713 7.72875C20.2715 8.72895 20.8334 10.0855 20.8334 11.5ZM18.1667 11.5C18.1667 12.2072 17.8858 12.8855 17.3857 13.3856C16.8856 13.8857 16.2073 14.1667 15.5001 14.1667C14.7928 14.1667 14.1146 13.8857 13.6145 13.3856C13.1144 12.8855 12.8334 12.2072 12.8334 11.5C12.8334 10.7927 13.1144 10.1145 13.6145 9.61437C14.1146 9.11427 14.7928 8.83332 15.5001 8.83332C16.2073 8.83332 16.8856 9.11427 17.3857 9.61437C17.8858 10.1145 18.1667 10.7927 18.1667 11.5Z",
    fill: "#EBB42C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5 0.833328C7.40004 0.833328 0.833374 7.4 0.833374 15.5C0.833374 23.6 7.40004 30.1667 15.5 30.1667C23.6 30.1667 30.1667 23.6 30.1667 15.5C30.1667 7.4 23.6 0.833328 15.5 0.833328ZM3.50004 15.5C3.50004 18.2867 4.45071 20.852 6.04404 22.8893C7.16302 21.4199 8.60657 20.229 10.2619 19.4097C11.9173 18.5905 13.7397 18.1651 15.5867 18.1667C17.4098 18.1649 19.2093 18.5794 20.8479 19.3784C22.4866 20.1774 23.9213 21.3399 25.0427 22.7773C26.198 21.2621 26.9758 19.4936 27.3119 17.6181C27.648 15.7426 27.5326 13.814 26.9754 11.992C26.4181 10.1699 25.435 8.50673 24.1074 7.14004C22.7797 5.77336 21.1457 4.74247 19.3406 4.13267C17.5354 3.52287 15.611 3.35169 13.7265 3.63329C11.8421 3.91489 10.0518 4.64118 8.50373 5.75207C6.9557 6.86295 5.69446 8.32649 4.82435 10.0216C3.95424 11.7167 3.50028 13.5946 3.50004 15.5ZM15.5 27.5C12.7453 27.5041 10.0737 26.5565 7.93737 24.8173C8.79728 23.5863 9.94182 22.5812 11.2736 21.8876C12.6054 21.1939 14.0851 20.8323 15.5867 20.8333C17.0696 20.8321 18.5314 21.1848 19.8506 21.8619C21.1699 22.539 22.3085 23.5211 23.172 24.7267C21.0191 26.5223 18.3035 27.5039 15.5 27.5Z",
    fill: "#EBB42C"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_79_24"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.1d067e450af7c93aeb154730c813178e.svg";
export { ForwardRef as ReactComponent };